module.exports = __webpack_public_path__ + "media/images/letter-A-a00bf1a837baf6df1de14d39ea5b43ad.png";